<template>
  <div class="container-contact">
    <div class="contact">
      <a
        target="_blank"
        href="http://wpa.qq.com/msgrd?v=3&uin=75965375&site=qq&menu=yes"
      >
        <b-img
          class="contact-icon"
          src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-contact-float.svg"
          alt="宁波天鑫仪表有限公司"
        ></b-img>
        <div
          v-if="isRouterAlive"
          :class="
            $i18n.locale == 'zh'
              ? ' contact-r contact-text fontsiyuanregular'
              : ' contact-l contact-text fontsiyuanregular'
          "
        >
          {{ $t("pageservice.title") }}
          <!-- 在<br />线<br />客<br />服 -->
        </div>
      </a>
      <div v-if="returnEnable" class="contact-return" @click="returnClick">
        <b-img
          class="contact-icon-return"
          src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/uptotop.png"
        ></b-img>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: "Contact",
  components: {},
  computed: {
    returnEnable() {
      return this.$store.state.returnEnable;
    },
  },
  data() {
    return {
      icon:
        "https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/uptotop.png",
      isRouterAlive: true,
    };
  },
  mounted() {
    this.getPageService();
  },
  methods: {
    returnClick() {
      document.getElementById("app").scrollIntoView();
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    getPageService() {
      const _this = this;
      this.$store.dispatch("getPageService").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);
        _this.reload();
      });
    },
  },
};
</script>

<style>
.container-contact {
  position: fixed;
  top: 40vh;
  right: 0;
  width: 45px;
  z-index: 9999;
  cursor: pointer;
  background: #ffffff00;
}
.contact {
  height: 150px;
  width: 45px;
  background: #c00f31c0;
  /* border-radius: 7px 0 0 7px; */
}
.contact-icon {
  width: 20px;
  height: 25px;
  margin-left: 12.5px;
  margin-top: 12px;
}
.contact-text {
  text-align: center;
  margin-left: 15px;
  margin-top: 5px;
  width: 12px;
  color: #fff;
}

.contact-text.contact-r {
  word-break: break-all; 
  font-size: 15px;
}

.contact-text.contact-l {
  font-size: 20px;
  letter-spacing:2px;
  word-break: normal;
  writing-mode: horizontal-tb;
  transform: rotate(90deg);
  -ms-transform: rotate(90deg); /* Internet Explorer 9*/
  -moz-transform: rotate(90deg); /* Firefox */
  -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
  -o-transform: rotate(90deg); /* Opera */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}

.contact-return {
  position: absolute;
  top: 153px;
  height: 40px;
  width: 45px;
  background: #85858566;
}

.contact-icon-return {
  width: 25px;
  margin-left: 11px;
  margin-top: 8px;
}

@media only screen and (max-width: 500px) {
  .container-contact {
    position: fixed;
    top: 40vh;
    right: 0;
    width: 40px;
    z-index: 999;
    cursor: pointer;
    background: #ffffff00;
  }
  .contact {
    height: 40px;
    width: 40px;
    background: #c00f31c0;
    /* border-radius: 7px 0 0 7px; */
  }
  .contact-icon {
    width: 23px;
    height: 23px;
    margin-left: 8px;
    margin-top: 10px;
  }

  .contact-text {
    display: none;
    /* margin-left: 7px;
    margin-top: 5px;
    font-size: 12px;
    color: #fff; */
  }
  .contact-return {
    position: absolute;
    top: 43px;
    height: 40px;
    width: 40px;
    background: #85858566;
  }
  .contact-icon-return {
    width: 23px;
    height: 23px;
    margin-left: 8px;
    margin-top: 10px;
  }
}
</style>
